import React from "react";
import PropTypes from "prop-types";

const WaveTextLoader = ({
  text = "Generating ...",
  textSize = "text-sm",
  textColor = "text-gray-600",
  fontWeight = "font-semibold",
}) => {
  return (
    <div className="flex justify-center items-center space-x-0.5">
      {text.split("").map((char, index) => (
        <span
          key={`${char}-${index}`}
          className={`inline-block ${textSize} ${fontWeight} ${textColor} animate-pulse `}
          style={{
            animationDelay: `${index * 100}ms`,
            animationDuration: "1.8s",
          }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </div>
  );
};

WaveTextLoader.propTypes = {
  text: PropTypes.string,
  textSize: PropTypes.string,
  textColor: PropTypes.string,
  fontWeight: PropTypes.string,
};

export default WaveTextLoader;
